// Hybrid Notification System (Browser Notification + Audio)
let permissionGranted = false;
let notificationAudio = null;
let notificationInterval = null;
let notificationTimeout = null;

// Initialize permission
if (typeof window !== 'undefined' && 'Notification' in window) {
    if (Notification.permission === 'granted') {
        permissionGranted = true;
    } else if (Notification.permission !== 'denied') {
        Notification.requestPermission().then(p => permissionGranted = (p === 'granted'));
    }
}

// Create audio element
const createAudio = () => {
    if (!notificationAudio) {
        // Beep sound
        notificationAudio = new Audio('https://notificationsounds.com/storage/sounds/file-sounds-1150-pristine.mp3');
        notificationAudio.volume = 0.5;
        notificationAudio.loop = false;
    }
    return notificationAudio;
};

// Play notification
export const playNotificationSound = (conversationId, customerName) => {
    console.log('🔊 Initiating notification sequence for:', customerName);

    // 1. Show Desktop Notification (guaranteed system sound if permission granted)
    if (permissionGranted && 'Notification' in window) {
        try {
            const notification = new Notification('New Message 💬', {
                body: `${customerName || 'A customer'} sent you a message`,
                icon: '/logo192.png',
                tag: `chat-${conversationId}`,
                requireInteraction: true,
                silent: false
            });
            notification.onclick = () => { window.focus(); notification.close(); };
        } catch (e) {
            console.error('Notification API error:', e);
        }
    }

    // 2. Play Web Page Audio (looping for 30s)
    // This will work if user has interacted with page, or if browser allows it
    try {
        const audio = createAudio();

        // Reset any existing Loop
        stopNotificationSound();

        const playAudio = () => {
            audio.currentTime = 0;
            const playPromise = audio.play();

            if (playPromise !== undefined) {
                playPromise
                    .then(() => console.log('✅ Audio played successfully'))
                    .catch(e => console.log('⚠️ Audio autoplay blocked (expected if no interaction):', e.message));
            }
        };

        // Start loop
        playAudio();
        notificationInterval = setInterval(playAudio, 3000); // Repeat every 3s

        // Stop after 30s
        notificationTimeout = setTimeout(() => {
            stopNotificationSound();
            console.log('🔇 Notification sequence ended (30s timeout)');
        }, 30000);

    } catch (error) {
        console.error('Audio setup error:', error);
    }
};

// Stop all notifications
export const stopNotificationSound = () => {
    if (notificationInterval) {
        clearInterval(notificationInterval);
        notificationInterval = null;
    }
    if (notificationTimeout) {
        clearTimeout(notificationTimeout);
        notificationTimeout = null;
    }
    if (notificationAudio) {
        notificationAudio.pause();
        notificationAudio.currentTime = 0;
    }
    console.log('🔇 Stopped notification sound');
};

// Request permission manually
export const requestNotificationPermission = async () => {
    if ('Notification' in window) {
        const permission = await Notification.requestPermission();
        permissionGranted = (permission === 'granted');
        return permission;
    }
    return 'denied';
};
